export default {
  CREATE_PRODUCT: 'CREATE_PRODUCT',
  CREATE_VARIANT: 'CREATE_VARIANT',
  UPDATE_PRODUCT: 'UPDATE_PRODUCT',
  UPDATE_VARIANT: 'UPDATE_VARIANT',
};
